import type { ArchizeenTileVariant } from '@archipro-design/aria';
import type {
    PaginatedArticleTileProps,
    TileSizes,
} from '@modules/professional/type/company-articles';

import type { ArticleESLoader } from '@modules/professional/page/loaders/articles-page-loader.server';
import type { SearchResultItem } from '@modules/search';
import { mapESArchizeenTileViewModel } from '@modules/search/util/elasticsearch-archizeen-tile-view';
import type { User } from '~/server/types';

export const getArchizeenTileVariantSize = (index: number) => {
    const isEvenRow = Math.floor(index / 4) % 2 === 0;
    const isEvenIndex = index % 2 === 0;

    const variant: ArchizeenTileVariant = isEvenIndex
        ? isEvenRow
            ? '02'
            : '01'
        : isEvenRow
        ? '01'
        : '02';

    const size: TileSizes = isEvenIndex
        ? isEvenRow
            ? 'medium'
            : 'small'
        : isEvenRow
        ? 'small'
        : 'medium';

    return { variant, size };
};

export const mapESArticleTileViewModel = (
    article: SearchResultItem,
    user?: User
): PaginatedArticleTileProps => {
    const data = mapESArchizeenTileViewModel(article, 'medium', user);
    return {
        title: data.tile.title as string,
        label: data.tile.label as string,
        date: data.tile.date as string,
        readTime: data.tile.readTime as string,
        image: data.tile.image as string,
        size: 'small',
        link: data.link,
        id: article.id,
        professionID: article.ProfessionalID,

        // editable item for hot buttons
        canEdit: data.tile.canEdit,
        bmEditorLink: data.tile.bmEditorLink,
        repositionThumbLink: data.tile.repositionThumbLink,
    };
};

export const mapESArticleComponentProps = (data: ArticleESLoader) => {
    return {
        articles: data.articleTiles,
        totalCount: data.searchResult?.nbHits ?? 0,
        totalPage: data.searchResult?.nbPages ?? 0,
        currentPage: data.pagination.page,
        pageSize: data.pagination.pageSize,
        initialSort: 0,
        hasPreviousPage: data.pagination.prevPage > 0,
        hasNextPage:
            data.pagination.nextPage <= (data.searchResult?.nbPages ?? 0),
    };
};
